import { useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../api";
import urls from "../urls";
import type { SiteCategoriesSummaryResponse } from "../utils/backend-types";

function useSiteCategoriesSummary() {
  const {
    isLoading,
    error,
    data: siteCategoriesSummary
  } = useQuery({
    queryKey: ["siteCategoriesSummary"],
    queryFn: () => fetchSiteCategoriesSummary(),
    refetchInterval: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity
  });

  return { isLoading, error, siteCategoriesSummary };
}

async function fetchSiteCategoriesSummary() {
  const response =
    await apiWithoutCamelization.get<SiteCategoriesSummaryResponse>(
      urls.apiWithoutCamelization.siteCategoriesSummary()
    );
  return response.data;
}

export { useSiteCategoriesSummary };
